import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Login from './components/Login/Login'
import Logout from './components/Logout/Logout'
import ForgotPassword from './components/Forgot-password/Forgot-password';
import ResetPassword from './components/Reset-password/Reset-password';
import Layout from './components/Layout/Layout'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import { authCheckState, setAuthRedirectPath, newMessageListener } from './store/actions';


const Note = props => {
    return (
        <div>
            <div className="toast-header">
                <span className="avatar small light mr-15">{ props.firstLetters }</span>
                <h4 className="ellipsis ">{ props.name }</h4>
            </div>
            <div className="toast-body">
                <div className="top">
                    <span>ID: { props.id }</span>
                </div>
                <p className="ellipsis">{ props.message }</p>
            </div>
        </div>
    );
};

class App extends Component {
    toastId = null;

    componentDidMount () {
        this.props.tryAutoSignin();
        this.props.newMessageListener();
    }

    getFirstLetters = value => value.substr(0, 2).toUpperCase();

    notify = () => this.toastId = toast("Hello", { autoClose: false });

    update = (userData, message)=> {
        if(userData){
            const data = {
                name: (userData.first_name) + ' ' + userData.last_name,
                firstLetters: this.getFirstLetters(userData.first_name),
                id: userData.user_id,
                message,
            };
            toast.update(this.toastId, { render: <Note {...data} />, type: toast.TYPE.INFO })
        }
    };

    render() {
        if (this.props.newMessage && this.props.newMessage.message.fromUser && this.props.isAuthenticated) {
            this.notify();
            this.update(this.props.newMessage.userData, this.props.newMessage.message.message);
            this.props.seenNewMessage();
        }
        let route;
        if (this.props.isAuthenticated) {
            route = (
                <Switch>
                    <Route path="/logout" exact component={Logout} />
                    <Route path="/forgot" exact component={ForgotPassword} />
                    <Route path="/reset" exact component={ResetPassword} />
                    <Route path="/login" component={ Login } />
                    <Route path="/" component={Layout} />

                </Switch>
            );
        } else {
            if (this.props.location.pathname !== '/login') {
                this.props.setAuthRedirectPath(this.props.location.pathname);
            }

            route = (
                <Switch>
                    <Route path="/login" component={ Login } />
                    <Route path="/forgot" component={ ForgotPassword } />
                    <Route path="/reset" component={ ResetPassword } />
                    <Redirect to="/login" />
                </Switch>
            );
        }

        return (
            <div>
                <ToastContainer
                    className='toast-container'
                    position="bottom-right"
                    autoClose={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                />
                { route }
            </div>
        );

    }
}


const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        newMessage: state.livechat.newMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        newMessageListener: () => dispatch( newMessageListener() ),
        tryAutoSignin: () => dispatch( authCheckState() ),
        setAuthRedirectPath: path => dispatch( setAuthRedirectPath(path) ),
        seenNewMessage: () => dispatch( { type: 'SEEN_NEW_MESSAGE' } )
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)( App ) );



// WEBPACK FOOTER //
// ./src/App.js